var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLt = function SvgLt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "matrix(.64143 0 0 .96773 0 0)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.93865 0 0 .69686 0 0)",
    rx: 0,
    ry: 0,
    width: 1063,
    height: 708.66,
    fill: "#007308"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.93865 0 0 .69686 0 0)",
    rx: 0,
    ry: 0,
    width: 1063,
    y: 475.56,
    height: 236.22,
    fill: "#bf0000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M0 0h997.77v164.61H0z"
  }))));
};
export default __webpack_public_path__ + "assets/11b8661d3c8dfd92db9e878ca263de79.svg";
export { SvgLt as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/lt.svg